import Link from './Link';
import { LAB_GUIDE_CLASSES } from '../constants/classNames';
import { ASSISTANT_NAME, ROUTES, SITE_NAME } from '../constants/config';
import '../styles/LabGuide.css';

const STEPS = [
  'Pick any two elements from the periodic table, or a lab bottle like water or acid.',
  `Press Mix and watch the beaker: it might fizz, flash, glow, melt into an alloy, or do nothing at all.`,
  `${ASSISTANT_NAME} explains what happened and why, with a fun fact and a safety note. Switch on "Read to me" to hear it.`,
];

const QUESTIONS = [
  {
    question: 'Is it safe for kids?',
    answer: `Yes. ${SITE_NAME} is a pretend lab, so nothing can spill, burn or explode. Every dangerous reaction comes with a note explaining how real scientists stay safe, and why you should never try it at home.`,
  },
  {
    question: 'Are the reactions real?',
    answer:
      'Yes. Every result is based on real chemistry: the product, a balanced equation, and when it happens (at room temperature, when heated, or only in a special lab). We simplify the words, not the science.',
  },
  {
    question: 'Why does nothing happen with some pairs?',
    answer:
      "Most pairs of substances don't react when simply mixed. Noble gases like helium almost never react, and some elements are so rare that nobody has ever had enough atoms to try.",
  },
  {
    question: 'Who is it for?',
    answer: 'Curious kids aged about 7 to 12, and the parents and teachers who explore science with them. It is free to use at home or in class.',
  },
];

/**
 * How-to and questions under the lab, so the page explains itself to visitors and search engines.
 */
export default function LabGuide() {
  return (
    <section className={LAB_GUIDE_CLASSES.root} aria-labelledby="lab-guide-heading">
      <h2 id="lab-guide-heading" className={LAB_GUIDE_CLASSES.heading}>
        How the {SITE_NAME} mixing lab works
      </h2>
      <ol className={LAB_GUIDE_CLASSES.steps}>
        {STEPS.map((step) => (
          <li key={step} className={LAB_GUIDE_CLASSES.step}>
            {step}
          </li>
        ))}
      </ol>

      <h2 className={LAB_GUIDE_CLASSES.heading}>Questions kids and grown-ups ask</h2>
      <div className={LAB_GUIDE_CLASSES.faq}>
        {QUESTIONS.map(({ question, answer }) => (
          <details key={question}>
            <summary className={LAB_GUIDE_CLASSES.question}>{question}</summary>
            <p className={LAB_GUIDE_CLASSES.answer}>{answer}</p>
          </details>
        ))}
      </div>

      <p className={LAB_GUIDE_CLASSES.links}>
        Want to read more? Explore <Link to={ROUTES.ELEMENTS}>all 118 elements</Link> or the{' '}
        <Link to={ROUTES.REACTIONS}>most famous chemical reactions</Link>.
      </p>
    </section>
  );
}
